import {cloneElement, ReactElement} from "react";
import {Link} from "react-router-dom";

/**
 * A reusable button component that acts as a link to a specified route.
 * Contains default responsive styling for both desktop and mobile devices.
 */
const UILinkButton = ({to, title, icon}: { to: string, title: string, icon: ReactElement }) => {
  const iconWithClass = cloneElement(icon, {className: `${icon.props.className ?? ""} ui-icon`.trim()});

  return (
    <Link to={to} className="btn btn-outline-light" aria-label={title} title={title}>
      <div className="d-none d-sm-block">{title}</div>
      <div className="d-block d-sm-none">{iconWithClass}</div>
    </Link>
  );
};
export default UILinkButton;